<template>
    <nav class="app-mobile-nav" aria-label="Mobile navigation">
        <router-link
            v-for="item in navItems"
            :key="item.to"
            :to="item.to"
        >
            <i :class="item.icon" aria-hidden="true"></i>
            <span>{{ item.shortLabel }}</span>
        </router-link>
    </nav>
</template>

<script>
export default {
    name: 'AppMobileNav',
    props: {
        navItems: {
            type: Array,
            default() {
                return []
            }
        }
    }
}
</script>
